module.exports = __webpack_public_path__ + "assets/success.png?2fbc513f398355e68614baa3ab50cfef";